import { render, staticRenderFns } from "./Detailed.vue?vue&type=template&id=6b7117c8&scoped=true"
import script from "./Detailed.vue?vue&type=script&lang=js"
export * from "./Detailed.vue?vue&type=script&lang=js"
import style0 from "./Detailed.vue?vue&type=style&index=0&id=6b7117c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7117c8",
  null
  
)

export default component.exports